import axios from "axios";
import { urlBaseWhatsapp } from './../../config/index';
import adminUserService from '../adminUser';

export default async function getTemplateListApi(
  eventId = '',
) {
  try {
    let _token = await adminUserService.getHallTokenByEventId(eventId);

    const _options = {
      url: `${urlBaseWhatsapp}/messages/templates`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "bearer " + _token,
      },
    };

    const _ret = await axios(_options);

    var _templates = [];
    _ret.data.forEach(item => {
      _templates = addTemplateToList(_templates, item);
    });

    _templates.sort((a, b) => (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0));
    return _templates;

  } catch (error) {
    console.log('Error getTemplateListApi', error);
    throw error;
  }

  function addTemplateToList(templateList = [], template) {
    const _numberOfTags = getNumberOfTagsFromMessage(template.text);

    var _obj = {
      text: template.name,
      value: template.name,
      nameSpace: template.namespace,
      message: template.text,
      numberOfTags: _numberOfTags,
      hasUrl: template.format ? true : false,
      urlType: template.format ? template.format : null
    }

    const _templateIndex = templateList.findIndex(t => t.value === template.name);
    if (_templateIndex >= 0 && templateList.length > 0) {
      if (!templateList[_templateIndex].message || templateList[_templateIndex].message === '') {
        templateList[_templateIndex].message = _obj.message;
        templateList[_templateIndex].numberOfTags = _obj.numberOfTags;
      }
      if (!templateList[_templateIndex].urlType || templateList[_templateIndex].urlType === '') {
        templateList[_templateIndex].urlType = _obj.urlType;
      }
      templateList[_templateIndex].hasUrl = true;
    } else {
      templateList.push(_obj);
    }

    return templateList;
  }

  function getNumberOfTagsFromMessage(message) {
    var _numberOfTags = 0;
    try {
      const _messageArray = message.split('{{');
      _messageArray.forEach(item => {
        if (item.includes('}}')) {
          _numberOfTags++;
        }
      });
    } catch (error) {
      if (error.message !== "Cannot read properties of null (reading 'split')") {
        console.log('Erro getNumberOfTagsFromMessage', error);
      }
    }

    return _numberOfTags;
  }
}
